import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function SummaryRow({ children, label }) {
    return (_jsxs("div", { className: "xs:flex-row xs:gap-1.5 flex flex-col items-center justify-between gap-0", children: [_jsx("div", { className: "text-body text-sm leading-6", children: label }), _jsx("div", { children: children })] }));
}
